import { BinaryReader } from "../../../binary";
import { createProtobufRpcClient } from "@cosmjs/stargate";
import { QueryParamsRequest, QueryParamsResponse, QueryCurrentRequest, QueryCurrentResponse, QueryListProjectsRequest, QueryListProjectsResponse, QueryListRequest, QueryListResponse, QueryNextToMonthExpiryRequest, QueryNextToMonthExpiryResponse, QuerySubscriptionTrackedUsageRequest, QuerySubscriptionTrackedUsageResponse, QueryEstimatedRewardsRequest, QueryEstimatedRewardsResponse, QueryEstimatedProviderRewardsRequest, QueryEstimatedValidatorRewardsRequest, QueryEstimatedValidatorRewardsResponse } from "./query";
export class QueryClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.params = this.params.bind(this);
        this.current = this.current.bind(this);
        this.listProjects = this.listProjects.bind(this);
        this.list = this.list.bind(this);
        this.nextToMonthExpiry = this.nextToMonthExpiry.bind(this);
        this.trackedUsage = this.trackedUsage.bind(this);
        this.estimatedRewards = this.estimatedRewards.bind(this);
        this.estimatedProviderRewards = this.estimatedProviderRewards.bind(this);
        this.estimatedValidatorRewards = this.estimatedValidatorRewards.bind(this);
    }
    params(request = {}) {
        const data = QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "Params", data);
        return promise.then(data => QueryParamsResponse.decode(new BinaryReader(data)));
    }
    current(request) {
        const data = QueryCurrentRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "Current", data);
        return promise.then(data => QueryCurrentResponse.decode(new BinaryReader(data)));
    }
    listProjects(request) {
        const data = QueryListProjectsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "ListProjects", data);
        return promise.then(data => QueryListProjectsResponse.decode(new BinaryReader(data)));
    }
    list(request = {}) {
        const data = QueryListRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "List", data);
        return promise.then(data => QueryListResponse.decode(new BinaryReader(data)));
    }
    nextToMonthExpiry(request = {}) {
        const data = QueryNextToMonthExpiryRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "NextToMonthExpiry", data);
        return promise.then(data => QueryNextToMonthExpiryResponse.decode(new BinaryReader(data)));
    }
    trackedUsage(request) {
        const data = QuerySubscriptionTrackedUsageRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "TrackedUsage", data);
        return promise.then(data => QuerySubscriptionTrackedUsageResponse.decode(new BinaryReader(data)));
    }
    estimatedRewards(request) {
        const data = QueryEstimatedRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "EstimatedRewards", data);
        return promise.then(data => QueryEstimatedRewardsResponse.decode(new BinaryReader(data)));
    }
    estimatedProviderRewards(request) {
        const data = QueryEstimatedProviderRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "EstimatedProviderRewards", data);
        return promise.then(data => QueryEstimatedRewardsResponse.decode(new BinaryReader(data)));
    }
    estimatedValidatorRewards(request) {
        const data = QueryEstimatedValidatorRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("lavanet.lava.subscription.Query", "EstimatedValidatorRewards", data);
        return promise.then(data => QueryEstimatedValidatorRewardsResponse.decode(new BinaryReader(data)));
    }
}
export const createRpcQueryExtension = (base) => {
    const rpc = createProtobufRpcClient(base);
    const queryService = new QueryClientImpl(rpc);
    return {
        params(request) {
            return queryService.params(request);
        },
        current(request) {
            return queryService.current(request);
        },
        listProjects(request) {
            return queryService.listProjects(request);
        },
        list(request) {
            return queryService.list(request);
        },
        nextToMonthExpiry(request) {
            return queryService.nextToMonthExpiry(request);
        },
        trackedUsage(request) {
            return queryService.trackedUsage(request);
        },
        estimatedRewards(request) {
            return queryService.estimatedRewards(request);
        },
        estimatedProviderRewards(request) {
            return queryService.estimatedProviderRewards(request);
        },
        estimatedValidatorRewards(request) {
            return queryService.estimatedValidatorRewards(request);
        }
    };
};
